<template >
  <div>
    <div>
      <div class="formPosition">
        <!-- ================================== ELIMINAR ========================================= -->



        <v-row justify="center">
          <v-dialog v-model="dialogoEliminar" persistent max-width="490">
            <v-card>
              <v-overlay :value="overlayEliminar">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
              <v-card-title class="headline">Desejas continuar com essa operação?</v-card-title>
              <v-card-text><b>Essa operação poderá afectar o sistema</b>, deseja continuar com a operação ? </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="black darken-1" text @click="dialogoEliminar = false">Cancelar</v-btn>
                <v-btn color="green darken-1" text @click="EliminarPrazoMulta()">Continuar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>



        <v-card style="margin:auto;" width="1200">
          <v-overlay :value="isLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
          <v-card-title style="background-color:#006699;color:white;"></v-card-title>
          <v-data-table :headers="headers" :items="valoresMulta" :search="searchInDb" sort-by="data_" class="elevation-3">
            <template v-slot:top>
              <v-toolbar flat color="white">

                <v-btn to="definir-valor" style="background-color:#006699;color:white;" outlined> <v-icon md
                    color="white darken-2">add</v-icon> Definir novo valor </v-btn>

                <v-divider class="mx-8" inset vertical></v-divider>
                <v-toolbar-title>Consultar valores de multa definidos</v-toolbar-title>
                <v-divider class="mx-8" inset vertical></v-divider>
                <!--  search  -->
                <div class="flex-grow-1"></div>
                <v-btn v-if="searchInDb" @click="initialize(searchInDb)" text icon color="green">
                  <v-icon>cached</v-icon>
                </v-btn>
                <v-text-field v-model="searchInDb" append-icon="search" label="Pesquisa" single-line
                  hide-details></v-text-field>
                <!-- end  search  -->
              </v-toolbar>
            </template>
            <template v-slot:item.valor_a="{ item }">
              <span v-if="item.tipoMulta === 'Fixo'">{{ utilitarios.IntegerToMoneyValueFatura(item.valor_a) }}</span>
              <span v-else>{{ item.valor_a }}%</span>
            </template>
            <template v-slot:item.valor_b="{ item }">
              <span v-if="item.tipoMulta === 'Fixo'">{{ utilitarios.IntegerToMoneyValueFatura(item.valor_b) }}</span>
              <span v-else>{{ item.valor_b }}%</span>
            </template>

            <template v-slot:item.action="{ item }">
              <v-menu bottom origin="center center" transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab dark small color="#006699" v-bind="attrs" v-on="on">
                    <v-icon dark>menu</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="SetEditMultaMensal(item)"><v-icon color="#006699" small>edit</v-icon>Editar Multa
                    Mensal</v-list-item>
                  <v-list-item @click="setEliminar(item)"><v-icon color="red" small>delete</v-icon>Eliminar</v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:no-data>
              Clica em + para adicionar novo estudante
            </template>
          </v-data-table>
        </v-card>

        <!-- ********************** EDITAR MULTA MENSAL *********************************************** -->

        <v-dialog v-model="showDialogMultaMensal" persistent max-width="600px">

          <v-card>
            <v-overlay :value="overlayEliminar">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-card-title>
              <span class="text-h5">Multa Mensal</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col md="12">
                    <v-card>
                      <v-col md="6"><span style="font-weight:bold;">Curso :</span> <span>{{ (editedItem !==
                        null) ? editedItem.curso : '' }}</span></v-col>
                      <v-col md="6"><span style="font-weight:bold;">académico : </span><span>{{ (editedItem !==
                        null) ? editedItem.classe : '' }}</span></v-col>
                      <v-col md="6"><span style="font-weight:bold;">Multa Diária : </span> <span>{{ (editedItem !== null) ?
                        utilitarios.IntegerToMoneyValueFatura(editedItem.valor_a) : '' }}</span></v-col>
                      <v-col md="6"><span style="font-weight:bold;">Multa Mensal : </span><span>{{ (editedItem !==
                        null) ? utilitarios.IntegerToMoneyValueFatura(editedItem.valor_b) : '' }}</span></v-col>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="8" md="8">
                    <v-text-field label="Nova Multa Mensal" v-money="money" v-model="multaMensal"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="showDialogMultaMensal = false">
                Fechar
              </v-btn>
              <v-btn color="green darken-1" text @click="guardarMultaMensal()">
                Guardar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- ************************************************************************* -->
      </div>
    </div>
  </div>
</template>
<script>
import Swal from 'sweetalert2'
import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import { VMoney } from 'v-money'
import utilitarios from '../../plugins/utilitarios'
const ls = require('local-storage')
export default {
  directives: { mask, money: VMoney },
  data: () => ({
    money: {
      decimal: ',',
      thousands: '.',
      suffix: ' Kz',
      precision: 2,
      masked: false
    },
    dialogoEliminar: false,
    overlayEliminar: false,
    objecto: null,
    multaMensal: '',
    showDialogMultaMensal: false,
    headers: [
      {
        text: 'Curso',
        align: 'left',
        sortable: false,
        value: 'curso'
      },
      { text: 'Ano académico', value: 'classe' },
      { text: 'Tipo de multa', value: 'tipoMulta' },
      { text: 'Valor diario', value: 'valor_a' },
      { text: 'Valor mensal', value: 'valor_b' },
      { text: 'Data criação', value: 'created_at' },
      { text: 'Autor', value: 'autor' },
      { text: 'Ações', value: 'action' }
    ],
    valoresMulta: [],
    utilitarios: utilitarios,
    searchInDb: '',
    dialog: false,
    isLoading: false,
    overlay: false,
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    editedItem: null,
  }),

  computed: {
    isAdm() {
     return ls.get('role') === 'ROLE_ADM' || ls.get('role') === "ROLE_RCI";
    }
  },


  created() {

    this.initialize()

  },

  methods: {

    SetEditMultaMensal(item) {
      this.showDialogMultaMensal = true
      this.editedItem = item
    },

    setEliminar(item) {
      this.dialogoEliminar = true
      this.objecto = item
    },

    async guardarMultaMensal() {

      try {
        this.overlayEliminar = true
        let result = await axios.post('updateMultaMensal', { multa: utilitarios.MoneyValueToInteger(this.multaMensal), item: this.editedItem }).then((res) => res.data)
        if (result.affectedRows >= 1) {
          Swal.fire('Informação', 'Multa Mensal actualizada com sucesso', 'success')
          this.showDialogMultaMensal = false
          this.initialize()
        } else
          Swal.fire('Informação', 'Ocorreu um erro ao tentar efectuar a operação', 'error')
        this.overlayEliminar = false
      } catch (error) {
        Swal.fire('Informação', 'Ocorreu um erro ao tentar efectuar a operação', 'error')
      }

    },
    async EliminarPrazoMulta() {

      try {
        this.overlayEliminar = true
        let result = await axios.post('eliminarValorMulta', { data: this.objecto }).then((res) => res.data)
        if (result.affectedRows >= 1) {
          this.dialogoEliminar = false
          this.valoresMulta.splice(this.valoresMulta.indexOf(this.objecto), 1);
          utilitarios.showAlertMessage('success', 'Registro eliminado com sucesso.')
        } else {
          utilitarios.showAlertMessage('error', 'Ocorreu um erro ao tentar efectuar a operação.')
        }
        this.overlayEliminar = false
      } catch (error) {
        this.overlayEliminar = false
      }
    },
    openDialog() {
      this.dialog = true
    },

    async initialize() {
      try {
        this.isLoading = true
        this.valoresMulta = await axios.get('valoresMultaFindAll').then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        Swal.fire('Informação', 'Ocorreu um erro ao carregar os dados', 'error')
      } finally { this.isLoading = false }
    }

  }

}
</script>
 
<style scoped>
.bg {
  color: green;
  background: red
}
</style>
